import { Button, FormHelperText } from "@mui/material";
import { Grid } from "@mui/system";
import { AutoComplete, FieldControl, Map } from "../../../shared/components";
import { useAddSite } from "../hooks/useAddSite";
import { ProjectFormData } from "../types";

const SiteDialog = ({
  onSuccess,
  onCancel,
  formData
}: {
  onSuccess: (site: any) => void;
  onCancel: () => void;
  formData: ProjectFormData;
}) => {
  const {
    site,
    fieldErrors,
    handleFieldChange,
    handleAddressChange,
    handleSubmit,
    isSubmitting,
  } = useAddSite({onSuccess, formData});
  return (
    <Grid container p={2} spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <AutoComplete
          value={site.org}
          onSelect={(value) => handleFieldChange("org", value)}
          name="network"
          label="Organization"
          error={!!fieldErrors.org}
          helperText={fieldErrors.org}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AutoComplete
          value={site.region}
          onSelect={(value) => handleFieldChange("region", value)}
          name="region"
          label="Network"
          error={!!fieldErrors.region}
          helperText={fieldErrors.region}
          required
        />
      </Grid>
      <Grid size={{xs:12}}>
        <FieldControl
          variant="input"
          keyName="description"
          label="Site Description"
          value={site.description}
          onChange={handleFieldChange}
          error={!!fieldErrors.description}
          helperText={fieldErrors.description}
          required
        />
      </Grid>
      <Grid size={{xs:12}}>
        <FieldControl
          variant="input"
          keyName="code"
          label="Site Code"
          value={site.code}
          onChange={handleFieldChange}
          error={!!fieldErrors.code}
          helperText={fieldErrors.code}
          required
        />
      </Grid>
      {(site.region) && <Grid size={{ xs: 12, }} sx={{ height: 500, border: fieldErrors.address ? "0.5px solid red" : "none" }}>
        <Map
          network={site.region}
          initialLocation={{
            address: site.address || "",
            what3_words: site.what3_words || "",
            coordinates:
              site.lat && site.long
                ? ([site.long, site.lat] as [number, number])
                : null,
          }}
          onLocationChange={(location) => {
            handleAddressChange({
              address: location.address,
              what3_words: location.what3_words,
              lat: location.coordinates[1],
              long: location.coordinates[0],
            });
          }}
          disabled={false}
        />
        { fieldErrors.address && <FormHelperText sx={{ color: "red"}}>Please select address.</FormHelperText>}
      </Grid>}
      <Grid size={12} display="flex" justifyContent="flex-end" gap={2} px={1}>
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
          Add Site
        </Button>
      </Grid>
    </Grid>
  );
};

export default SiteDialog;
